import React, { useState } from 'react';
import MainStructure from '../components/general/MainStructure';
import ListView from './listview/ListView';
import Calendar from './calendar/Calendar';
import * as Icon from 'react-feather';
import { Link, useLocation } from 'react-router-dom';

function CalendarHome() {
  const [viewMode, setViewMode] = useState('calendar'); // 'list' or 'calendar'
  const [activeTab, setActiveTab] = useState('queue'); // 'queue', 'drafts', etc.


  const location = useLocation();

// Helper to check if the current path matches
const isPath = (path) => location.pathname === path;

  // --- Styled Constants ---
  const segmentedControlStyle = {
    backgroundColor: '#f1f3f5',
    padding: '4px',
    borderRadius: '10px',
    display: 'inline-flex',
    border: '1px solid #e9ecef'
  };

  const getToggleButtonStyle = (active) => ({
    padding: '8px 20px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: active ? '#ffffff' : 'transparent',
    boxShadow: active ? '0 2px 6px rgba(0,0,0,0.1)' : 'none',
    color: active ? '#2c73d2' : '#5f6368',
    fontWeight: 700,
    fontSize: '14px',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    outline: 'none'
  });

  const tabItemStyle = (active) => ({
    cursor: 'pointer',
    fontWeight: 700,
    fontSize: '15px',
    color: active ? '#2c73d2' : '#6c757d',
    padding: '12px 4px',
    marginRight: '32px',
    position: 'relative',
    transition: 'color 0.2s ease',
  });

  const activeIndicatorStyle = {
    position: 'absolute',
    bottom: '-1px',
    left: 0,
    right: 0,
    height: '3px',
    backgroundColor: '#2c73d2',
    borderRadius: '3px 3px 0 0',
  };

  return (
    <MainStructure activeItem={"calendar-home"}>
      <div className="container-fluid p-0">
        
        {/* Header Section */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center">
             <div className="mr-3 p-2 d-flex align-items-center justify-content-center" 
                  style={{ backgroundColor: '#f8f9fa', borderRadius: '12px', border: '1px solid #e9ecef' }}>
                <Icon.Layers size={22} color="#2c73d2" />
             </div>
             <div>
                <h1 className="h3 mb-0" style={{ fontWeight: 800, letterSpacing: '-0.5px' }}>All Channels</h1>
                <p className="text-muted mb-0 small">Manage and schedule your content across all platforms</p>
             </div>
          </div>
          
          {/* Enhanced Segmented View Toggle */}
          <div style={segmentedControlStyle}>
    <Link 
      to="/publish"
      style={{
        ...getToggleButtonStyle(isPath('/publish')),
        display: 'flex',       // Ensure alignment stays consistent
        alignItems: 'center',
        textDecoration: 'none' // Remove default link underline
      }}
    >
      <Icon.List 
        size={16} 
        className="mr-2" 
        strokeWidth={isPath('/publish') ? 3 : 2} 
      /> 
      List
    </Link>

    <Link 
      to="/calendar-home"
      style={{
        ...getToggleButtonStyle(isPath('/calendar-home')),
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none'
      }}
    >
      <Icon.Calendar 
        size={16} 
        className="mr-2" 
        strokeWidth={isPath('/calendar-home') ? 3 : 2} 
      /> 
      Calendar
    </Link>
  </div>
        </div>

        {/* Professional Sub-Tabs */}

        {viewMode === 'list' &&
        <div className="d-flex border-bottom mb-4" style={{ borderColor: '#e9ecef !important' }}>
          {['Queue', 'Drafts', 'Approvals', 'Sent'].map((tab) => {
            const isActive = activeTab === tab.toLowerCase();
            return (
              <div
                key={tab}
                onClick={() => setActiveTab(tab.toLowerCase())}
                style={tabItemStyle(isActive)}
              >
                {tab}
                <span className="ml-2 py-0 px-2 rounded-pill border bg-light text-muted" 
                      style={{ fontSize: '11px', fontWeight: 600 }}>
                  0
                </span>
                {isActive && <div style={activeIndicatorStyle} />}
              </div>
            );
          })}
        </div> }

        {/* Dynamic Content Area */}
        <div className="animate__animated animate__fadeIn">
            <Calendar /> 
        </div>

      </div>
    </MainStructure>
  );
}

export default CalendarHome;